import * as React from 'react';
import { SVGProps } from 'react';

const SvgEllipsis = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 12a2 2 0 1 1-3.999.001A2 2 0 0 1 8 12zm12 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
  </svg>
);

export default SvgEllipsis;
